import { format } from 'date-fns'
import { ja } from 'date-fns/locale'

export function formatShipAt(date?: string): string {
  if (date) {
    return `${format(new Date(date), 'M/d（E）', { locale: ja })}に発送`
  } else {
    return '1〜3日で発送'
  }
}

export function formatDeliverAt(epoch: number | string): string {
  return format(new Date(epoch), 'M月d日（E）', { locale: ja })
}

export function formatTime(epoch: number | string): string {
  return format(new Date(epoch), 'M月d日（E）H:mm', { locale: ja })
}
